<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Add Category</h2>
        <form @submit.prevent="submitCategory">
          <input v-model="category.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Name" required />
          <input v-model="category.description" class="w-full p-2 border rounded-lg mb-4" placeholder="Description" required />
          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Add Category</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        category: {
          name: '',
          description : '',
        },
      };
    },
    methods: {
      ...mapActions('categories', { addCategory: 'addCategory' }),
      submitCategory() {
        this.addCategory(this.category);
        this.$emit('addCategory', this.category);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
  </script>
  